/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FormQualityEntry } from '../../models/form-quality-entry';
import { FormQualityEntryUpdateDtoList } from '../../models/form-quality-entry-update-dto-list';

export interface UpdateFormQualityEntries$Params {
  formId: string;
  body: FormQualityEntryUpdateDtoList;
}

export function updateFormQualityEntries(
  http: HttpClient,
  rootUrl: string,
  params: UpdateFormQualityEntries$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<FormQualityEntry>>> {
  const rb = new RequestBuilder(rootUrl, updateFormQualityEntries.PATH, 'put');
  if (params) {
    rb.path('formId', params.formId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FormQualityEntry>>;
    })
  );
}

updateFormQualityEntries.PATH = '/forms/{formId}/quality-entry';
